import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Loader } from '../Loader/Loader';
import { EmptyContainer, Empty } from './LoadingInventoryTable.styled';

export const LoadingInventoryTable = ({ loading }) => {
  const { t } = useTranslation();

  return (
    <TableRow hover tabIndex={-1}>
      <TableCell id={1} scope="row" colSpan={10}>
        <EmptyContainer>
          {loading ? <Loader /> : null}
          <Empty>
            {loading
              ? t('Inventory.table.loading')
              : t('Inventory.table.empty')}
          </Empty>
        </EmptyContainer>
      </TableCell>
    </TableRow>
  );
};

LoadingInventoryTable.propTypes = {
  loading: PropTypes.bool,
};
